import { render, staticRenderFns } from "./nr-password.vue?vue&type=template&id=333d8362&scoped=true&"
import script from "./nr-password.vue?vue&type=script&lang=js&"
export * from "./nr-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d8362",
  null
  
)

export default component.exports